import { getContainer } from '@framework/di/getContainer';
import createAsyncRequest from '@/creditflowresearch/infrastructure/state/createAsyncRequest';
import createAction from '@framework/state/createAction';
import ScorecardRepository from '@/creditflowresearch/infrastructure/repository/ScorecardRepository';
import { ITtmFilter } from '@/creditflowresearch/application/League/interfaces';
import actionTypes from './actionTypes';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';

interface IProps {
  page: number,
  perPage: number,
  selectedPeriod: ITtmFilter,
}

export default ({ page, perPage, selectedPeriod }:IProps, dispatch) => {
  const container = getContainer();
  const scorecardRepository: ScorecardRepository = container.get(ScorecardRepository);
  const {
    includedRegionIds,
    includedProductIds,
  } = usePageFiltersContext();

  const getTopRatingAgencies = (payload) => {
    const method = () => scorecardRepository.getTopCompaniesRatingAgency(payload);
    const request = createAsyncRequest<typeof method>({
      dispatch,
      method,
      types: [
        actionTypes.GET_COLLECTION,
        actionTypes.GET_COLLECTION_SUCCESS,
        actionTypes.GET_COLLECTION_ERROR,
      ],
    });

    return request();
  };

  const paginateTopRatingAgencies = (payload) => dispatch(createAction(actionTypes.PAGINATE, payload));
  const resetTopRatingAgencies = () => dispatch(createAction(actionTypes.RESET));
  const setTopRatingAgenciesData = (payload) => dispatch(createAction(actionTypes.GET_COLLECTION_SUCCESS, payload));

  const getTopRatingAgenciesByFilter = () => {
    const payload = {
      page,
      perPage,
      filters: {
        dateFrom: selectedPeriod.dateFrom,
        dateTo: selectedPeriod.dateTo,
        includedProductIds,
        includedRegionIds,
      },
    };

    getTopRatingAgencies(payload);
  };

  return {
    paginateTopRatingAgencies,
    resetTopRatingAgencies,
    getTopRatingAgenciesByFilter,
    setTopRatingAgenciesData,
  };
};
